module.exports = __webpack_public_path__ + "img/IMG_20191125_200516.8f3b3d69.jpg";